import { render } from "./NfseServiceForm.vue?vue&type=template&id=15370d84"
import script from "./NfseServiceForm.vue?vue&type=script&lang=js"
export * from "./NfseServiceForm.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__